export const classes = {
  pill: 'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold',
  dot: 'size-1.5 shrink-0 rounded-full',
};
